import { render } from "./NoteMarkUi.vue?vue&type=template&id=a18ed3ca&scoped=true&ts=true"
import script from "./NoteMarkUi.vue?vue&type=script&lang=ts"
export * from "./NoteMarkUi.vue?vue&type=script&lang=ts"

import "./NoteMarkUi.vue?vue&type=style&index=0&id=a18ed3ca&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a18ed3ca"]])

export default __exports__